'use strict';

module.exports = require('./ReactSafeHtml');


//////////////////
// WEBPACK FOOTER
// ./~/react-safe-html/lib/index.js
// module id = 1131
// module chunks = 0